<template>
    <div
        id="main_video"
        class="p-4 d-inline-flex flex-column align-items-center"
    >
        <h2 id="helpVideoTitle" class="mb-4 align-self-start text-primary" v-text="topic?.title"></h2>
        <div id="video_wrapper" class="h-100">
            <video-player
                :poster="topic?.video?.thumbnail"
                :options="videoConfigs"
                @video:end="() => $emit('next')"
                :width="onboarding ? '480' : '720'"
            ></video-player>
        </div>
    </div>
</template>

<script>
import VideoPlayer from './VideoPlayer.vue';

export default {
    name: "player",
    components: {
        VideoPlayer
    },
    props: {
        topic: {
            type: Object,
            default: () => {
                return {};
            },
        },
        onboarding: false,
    },

    data() {
        return {
            show: true,
            videoConfigs: {
                controls: true,
                responsive: true,
                restoreEl: true,
                skipButtons: true,
                autoplay: this.onboarding,
                // src: this.topic?.video?.video_url,
                type: "application/x-mpegURL",
                // sources: [
                //     {
                //         src: this.topic?.video?.video_url,
                //         type: "application/x-mpegURL"
                //     }
                // ]
            }
        }
    },

    mounted() {

        this.$nextTick(function () {
            this.videoConfigs = {
                controls: true,
                responsive: true,
                restoreEl: true,
                skipButtons: true,
                src: this.topic?.video?.video_url,
                type: "application/x-mpegURL",
            }
        })
    },


    watch: {
        topic(newTopic) {
            this.videoConfigs = {
                controls: true,
                responsive: true,
                restoreEl: true,
                skipButtons: true,
                src: newTopic?.video?.video_url,
                type: "application/x-mpegURL",
            }
        }
    },
};
</script>
